import { getBulkDiscountsForVariantOption, getTieredOptionLine } from '@repo/lib';
import isPwywOption from './isPwywOption';

const getOptionDiscountAmount = (bulkDiscounts, option, quantity) =>
  getTieredOptionLine({
    unitPrice: option.additionalChargeAmount,
    quantity,
    bulkDiscounts: getBulkDiscountsForVariantOption(bulkDiscounts, option._id),
  }).discountAmount;

export default function getOneTimeVariantsAmount(
  selectedVariants,
  checkoutQuantity,
  type,
  bulkDiscounts = [],
) {
  if (!selectedVariants || !selectedVariants.length)
    return { oneTimeVariantsAmount: 0, oneTimeVariantsDiscountAmount: 0 };

  return selectedVariants.reduce(
    (acc, variant) => {
      if (!variant || (!variant.selectedOption && !variant.selectedOptions)) {
        return acc;
      }

      let variantAmount = 0;
      let variantDiscountAmount = 0;

      if (variant.selectionType === 'single') {
        const { additionalChargeAmount } = variant.selectedOption;

        if (
          type === 'subscription' &&
          variant.selectedOption.type !== 'one_time' &&
          !isPwywOption(variant.selectedOption)
        ) {
          return acc;
        }

        const amount = variant.increasesWithQuantity
          ? additionalChargeAmount * checkoutQuantity
          : additionalChargeAmount;

        variantAmount = amount;
        variantDiscountAmount = getOptionDiscountAmount(
          bulkDiscounts,
          variant.selectedOption,
          variant.increasesWithQuantity ? checkoutQuantity : 1,
        );
      } else if (variant.selectionType === 'quantity') {
        variantAmount = variant.selectedOptions.reduce((optionAcc, selectedOption) => {
          if (!selectedOption || selectedOption.quantity === 0) {
            return optionAcc;
          }

          if (
            type === 'subscription' &&
            selectedOption.type !== 'one_time' &&
            !isPwywOption(selectedOption)
          ) {
            return optionAcc;
          }

          const amount = selectedOption.additionalChargeAmount * selectedOption.quantity;

          variantDiscountAmount += getOptionDiscountAmount(
            bulkDiscounts,
            selectedOption,
            selectedOption.quantity,
          );
          return optionAcc + amount;
        }, 0);
      } else if (variant.selectionType === 'multiple') {
        variantAmount = variant.selectedOptions.reduce((optionAcc, selectedOption) => {
          if (!selectedOption || selectedOption.quantity === 0) {
            return optionAcc;
          }

          if (
            type === 'subscription' &&
            selectedOption.type !== 'one_time' &&
            !isPwywOption(selectedOption)
          ) {
            return optionAcc;
          }

          const amount = variant.increasesWithQuantity
            ? selectedOption.additionalChargeAmount * checkoutQuantity
            : selectedOption.additionalChargeAmount;

          variantDiscountAmount += getOptionDiscountAmount(
            bulkDiscounts,
            selectedOption,
            variant.increasesWithQuantity ? checkoutQuantity : selectedOption.quantity,
          );
          return optionAcc + amount;
        }, 0);
      }

      return {
        oneTimeVariantsAmount: acc.oneTimeVariantsAmount + variantAmount,
        oneTimeVariantsDiscountAmount: acc.oneTimeVariantsDiscountAmount + variantDiscountAmount,
      };
    },
    { oneTimeVariantsAmount: 0, oneTimeVariantsDiscountAmount: 0 },
  );
}
